import { Box } from '@mui/material';

import { EDGE_CHIP_SX, EDGE_LETTER_INSET_PX } from '~/viewportGrid/chrome';
import type { EdgeLabels } from '~/viewportGrid/tile/tileViewModel';

/**
 * The four orientation letters, each centred on the edge it names. Placed
 * absolutely: the parent is the box whose edges are lettered.
 */
export default function EdgeLetters({ top, bottom, left, right }: EdgeLabels) {
    return (
        <>
            <Box
                data-testid="edge-top"
                sx={{
                    ...EDGE_CHIP_SX,
                    top: EDGE_LETTER_INSET_PX,
                    left: '50%',
                    transform: 'translateX(-50%)',
                }}
            >
                {top}
            </Box>
            <Box
                data-testid="edge-bottom"
                sx={{
                    ...EDGE_CHIP_SX,
                    bottom: EDGE_LETTER_INSET_PX,
                    left: '50%',
                    transform: 'translateX(-50%)',
                }}
            >
                {bottom}
            </Box>
            <Box
                data-testid="edge-left"
                sx={{
                    ...EDGE_CHIP_SX,
                    left: EDGE_LETTER_INSET_PX,
                    top: '50%',
                    transform: 'translateY(-50%)',
                }}
            >
                {left}
            </Box>
            <Box
                data-testid="edge-right"
                sx={{
                    ...EDGE_CHIP_SX,
                    right: EDGE_LETTER_INSET_PX,
                    top: '50%',
                    transform: 'translateY(-50%)',
                }}
            >
                {right}
            </Box>
        </>
    );
}
